/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */




import { connect } from 'react-redux';


import DataContainer from 'Util/Request/DataContainer';
import CmsCounterComponent from "Component/CmsCounter/CmsCounter.component";


export class CmsCounter extends DataContainer {


    render() {
        return <CmsCounterComponent {...this.props}>

        </CmsCounterComponent>
    }
}

export default connect(null, null)(CmsCounter);
